import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialsModule } from '@library/common/materials';
import { PipesModule } from '@library/core/pipes';

import { DialogsModule } from '@library/common';
import { StatusLegendModule } from '@library/modules/status-legend';
import { HttpPaginationModule } from '@library/modules/http-pagination';
import { LoadingModule } from '@library/modules/loading';
import { ErrorsModule } from '@library/modules/errors';

import { ReportsRoutingModule } from './reports-routing.module';

import { ReportsWrapperComponent } from './reports-wrapper.component';
import { ListComponent } from './list/list.component';
import { ReportComponent } from './report/report.component';
import { DisplayComponent } from './display/display.component';
import { RdateFilterComponent } from './rdate-filter/rdate-filter.component';
import { FiltersComponent } from './display/filters/filters.component';
import { FieldsComponent } from './display/fields/fields.component';
import { NewReportComponent } from './new-report/new-report.component';
import { EditReportComponent } from './edit-report/edit-report.component';
import { CopyReportComponent } from './copy-report/copy-report.component';
import { RecoverReportComponent } from './recover-report/recover-report.component';
import { ScheduleReportComponent } from './schedule-report/schedule-report.component';
import { RecurrenceComponent } from './schedule-report/recurrence/recurrence.component';
import { AmazingTimePickerModule } from '@jonijnm/amazing-time-picker';
import { ScheduleTimeZoneComponent } from './schedule-report/schedule-time-zone/schedule-time-zone.component';
import { RecipientsComponent } from './schedule-report/recipients/recipients.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
   declarations: [
      ReportsWrapperComponent,
      ListComponent,
      ReportComponent,
      DisplayComponent,
      RdateFilterComponent,
      FiltersComponent,
      FieldsComponent,
      NewReportComponent,
      EditReportComponent,
      CopyReportComponent,
      RecoverReportComponent,
      ScheduleReportComponent,
      RecurrenceComponent,
      ScheduleTimeZoneComponent,
      RecipientsComponent,
   ],
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,

      MaterialsModule,
      PipesModule,

      DialogsModule,
      StatusLegendModule,
      HttpPaginationModule,
      LoadingModule,
      ErrorsModule,

      ReportsRoutingModule,
      AmazingTimePickerModule,
      NgxMatSelectSearchModule,

   ],
})
export class ReportsModule { }
